import './TextTitle.css';

const __ttStyleTagId = 'text-title-dynamic-styles';

const __ttEnsureStyleTag = () => {
  if (typeof document === 'undefined') return null;
  let tag = document.getElementById(__ttStyleTagId);
  if (!tag) {
    tag = document.createElement('style');
    tag.id = __ttStyleTagId;
    document.head.appendChild(tag);
  }
  return tag;
};

const __ttHash = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h).toString(36);
};

const __ttToCssSize = (v) => (typeof v === 'number' ? `${v}px` : (v ?? ''));

const __ttEnsureRule = (className, cssText) => {
  const tag = __ttEnsureStyleTag();
  if (!tag) return;
  if (tag.textContent.includes(`.${className}{`)) return;
  tag.appendChild(document.createTextNode(`\n.${className}{${cssText}}\n`));
};

const __ttGetDynClass = (opts) => {
  const payload = JSON.stringify(opts);
  const cls = `texttitle-dyn-${__ttHash(payload)}`;

  const fontSize = __ttToCssSize(opts.titleSize);
  const color = opts.color ?? '';
  const align = opts.alignment ?? '';
  const family = opts.fontFamily ?? 'inherit';
  const weight = opts.fontWeight ?? 'inherit';
  const style = opts.fontStyle ?? 'normal';
  const deco = opts.textDecoration ?? 'none';

  const safeFamily = String(family || '')
    .replace(/;/g, '')
    .trim();

  __ttEnsureRule(
    cls,
    `--texttitle-font-size:${fontSize || 'var(--widget-responsive-title-size, inherit)'};` +
      `--texttitle-color:${color || 'inherit'};` +
      `--texttitle-align:${align || 'inherit'};` +
      `--texttitle-font-family:${safeFamily || 'inherit'};` +
      `--texttitle-font-weight:${weight || 'inherit'};` +
      `--texttitle-font-style:${style || 'normal'};` +
      `--texttitle-text-decoration:${deco || 'none'};`
  );

  return cls;
};

const TextTitle = ({
  transparentBackground,
  title,
  titleSize,
  color,
  alignment,
  fontFamily,
  fontWeight,
  fontStyle,
  textDecoration,
  draggable
}) => {
  const dynClass = __ttGetDynClass({
    titleSize,
    color,
    alignment,
    fontFamily,
    fontWeight,
    fontStyle,
    textDecoration
  });

  const setGrabbing = (e, on) => {
    if (!draggable) return;
    const el = e.target.closest('.widget-container');
    if (!el) return;
    el.classList.toggle('is-grabbing', Boolean(on));
  };

  return (
    <div
      className={
        `widget-container text-title-widget ${dynClass} ` +
        `${draggable ? 'is-draggable' : 'not-draggable'} ` +
        `${transparentBackground ? 'is-transparent' : ''}`
      }
      onMouseDown={(e) => setGrabbing(e, true)}
      onMouseUp={(e) => setGrabbing(e, false)}
      onMouseLeave={(e) => setGrabbing(e, false)}
      draggable={draggable}
      onDragStart={(e) => {
        const id = e.target.closest('.widget').id;
        const rect = e.target.getBoundingClientRect();
        const offsetX = e.clientX - rect.x;
        const offsetY = e.clientY - rect.y;

        let dragData = `text-title;${id};${offsetX};${offsetY};`;
        dragData += id.startsWith('base') ? 'add' : 'move';
        e.dataTransfer.setData('text/plain', dragData);
      }}
    >
      <h3 className="text-title-widget__title">{title}</h3>
    </div>
  );
};

export default TextTitle;
